<script setup lang="ts">
import { getFinancialReportList } from '@/api/modules/home'

definePage({
  name: 'financial-report',
  meta: {
    title: '一图财报',
  },
})

const option = [
  { text: '全部', value: 0 },
  { text: '港股', value: 1 },
  { text: '美股', value: 2 },
]

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)
const type = ref(0)

async function onLoad() {
  try {
    const { status, data } = await getFinancialReportList({
      page: 1,
      pageSize: 20,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <FmPageLayout navbar back class="page">
    <template #navbar-end>
      <FmIcon name="material-symbols:help-outline-rounded" class="text-22px color-[#fff]" />
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="bg-[#fff]">
        <div class="flex items-center p-r-7px">
          <div class="flex-1">
            <van-search placeholder="请输入关键字/股票代码" />
          </div>
          <div class="dropdown w-93px">
            <van-dropdown-menu z-index="99">
              <van-dropdown-item v-model="type" :options="option" />
            </van-dropdown-menu>
          </div>
        </div>
        <vxe-table
          header-row-class-name="table-header"
          :data="list"
        >
          <vxe-column field="title" title="标题" />
          <vxe-column width="30%" field="updateTime" title="更新时间" align="right" />
        </vxe-table>
      </div>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.page {
  .dropdown {
    :deep(.van-dropdown-menu__bar) {
      height: 34px;
      background-color: #f1f2f7;
      border-radius: 5px;
      box-shadow: none;
    }

    :deep(.van-dropdown-menu__title::after) {
      border-color: transparent transparent #999 #999;
    }
  }
}
</style>
